import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/components/Common";
import { Page, PageHeader, Loading, ErrorNote, RichText } from "@/components/Common";

export default function TheoryPage() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    setPage(null);
    setErr(false);
    api.get(`/pages/${slug}`).then((r) => setPage(r.data)).catch(() => setErr(true));
  }, [slug]);

  if (err) return <Page><ErrorNote message="صفحہ نہیں ملا" /></Page>;
  if (!page) return <Page><Loading /></Page>;

  const crumbs = [{ label: "UGC NET اردو", to: "/ugc-net" }];
  if (page.unitNum) crumbs.push({ label: `یونٹ ${page.unitNum}`, to: `/ugc-net/unit/${page.unitNum}` });
  crumbs.push({ label: page.title });

  return (
    <Page className="max-w-4xl">
      <PageHeader title={page.title} crumbs={crumbs} />
      <article className="bg-[#fdfbf7] border border-[#d4af37]/40 rounded-2xl p-6 sm:p-10 shadow-[0_4px_20px_rgba(42,21,8,0.06)]" data-testid="theory-content">
        <RichText text={page.content} />
      </article>
      {page.links?.length > 0 && (
        <div className="mt-8" data-testid="theory-links">
          <div className="flex flex-wrap gap-3">
            {page.links.map((l, i) =>
              l.to ? (
                <Link key={i} to={l.to} data-testid={`theory-link-${i}`} className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full bg-[#2a1508] text-[#f5efe3] hover:bg-[#4a2b16] transition-colors">
                  {l.label} <ArrowLeft size={15} />
                </Link>
              ) : (
                <span key={i} data-testid={`theory-link-muted-${i}`} className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-dashed border-[#c5a059]/70 text-[#5c3a21]">
                  {l.label} <span className="text-sm">(جلد)</span>
                </span>
              )
            )}
          </div>
        </div>
      )}
    </Page>
  );
}
